import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { Box } from "@mui/material";
import { ArticlesApi } from "../api/AdminApi";
import { postData } from "../api/AuthenticatedApiCaller";
import OperationResult from "../commons/OperationResult";

export default function StaticArticlesAddDialog(props) {
  const updatedArticle = JSON.parse(JSON.stringify(props.article));

  const [hasError, setHasError] = useState(null);

  async function save() {
    let [data, error] = await postData(ArticlesApi.setArticle, updatedArticle);
    if (!error) {
      setHasError(false);
    } else {
      setHasError(true);
    }
    props.save();
  }

  return (
    <Box>
      {hasError !== null && <OperationResult success={!hasError} />}

      {updatedArticle !== null && (
        <Dialog open={props.open}>
          <DialogTitle>Edit Static Article{updatedArticle.name}</DialogTitle>
          <DialogContent>
            <Stack
              sx={{ width: "100%", height: "100%" }}
              component="paper"
              spacing={4}
            >
              {updatedArticle.labeledContents.map((labeledContent) => (
                <React.Fragment>
                  <TextField
                    multiline
                    defaultValue={labeledContent.label}
                    label={"Title " + labeledContent.language}
                    onChange={(event) => {
                      labeledContent.label = event.target.value;
                    }}
                  />
                  <TextField
                    multiline
                    defaultValue={labeledContent.text}
                    label={"Text " + labeledContent.language}
                    onChange={(event) => {
                      labeledContent.text = event.target.value;
                    }}
                  />
                </React.Fragment>
              ))}
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button onClick={save}>Save</Button>
            <Button onClick={props.cancel} autoFocus>
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Box>
  );
}
